/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const loadersDirective = require('./loadersDirective');

const loadersModule = angular
    .module('enervee_utils.loaders', [])
    .directive('loaders', loadersDirective);

module.exports = loadersModule;